module.exports = __webpack_public_path__ + "static/img_1343-72b01e69bb7c97d3f9241f7e6d24db1f.webp";